import React from 'react';
import type { PlayerMethodsType } from '../utils/playerMethods';
import type {
  TranslateKeysCMSKeysType,
  TranslateKeysCMSType,
} from '../translates/translateKeysCMS';

type TranslateMapContextValue = TranslateKeysCMSType & {
  translateFunc: PlayerMethodsType['translate'];
} & {
  getTranslate: {
    [key in TranslateKeysCMSKeysType]: (
      params?: Parameters<PlayerMethodsType['translate']>[1]
    ) => string;
  };
};

export const TranslateMapContext =
  React.createContext<TranslateMapContextValue>({} as TranslateMapContextValue);
